import {Injectable} from '@angular/core';
import {BaseService} from '../../base-service';
import {ApiConfiguration} from '../../api-configuration';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {StrictHttpResponse} from '../../strict-http-response';
import {PayloadResponse} from '../../models/payload-response';

@Injectable({
  providedIn: 'root',
})
export class TokenService extends BaseService {

  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  getPayloadFromTokenResponse(token: string): Observable<PayloadResponse> {
    return this._getPayloadFromTokenResponse(token).pipe(
      map(response => response.body as PayloadResponse)
    );
  }

  private _getPayloadFromTokenResponse(token: string): Observable<StrictHttpResponse<PayloadResponse>> {
    const url = `${this.rootUrl}/getPayloadFromToken/?token=${token}`;
    return this.http.get<PayloadResponse>(url, {
      observe: 'response'
    });
  }
}
